/* Ghost injects its own UI roots (member portal, search overlay,
   announcement bar) into <body> at runtime. Turbo body swaps would
   destroy them, so move the live nodes into the incoming body before
   each render. Their scripts live in <head> and only run once. */
(function () {
    const ROOT_IDS = ['ghost-portal-root', 'sodo-search-root', 'announcement-bar-root'];

    document.addEventListener('turbo:before-render', function (event) {
        const newBody = event.detail && event.detail.newBody;
        if (!newBody) return;

        ROOT_IDS.forEach(function (id) {
            const el = document.getElementById(id);
            if (el && !newBody.querySelector('#' + id)) {
                newBody.appendChild(el);
            }
        });
    });

    /* Portal and sodo-search bind click handlers directly to trigger
       buttons when they boot, so buttons in a swapped-in body are unbound.
       Portal links (#/portal/...) still work through its hashchange
       listener; for search we route through the #/search hash, which
       sodo-search also listens for. */
    document.addEventListener('click', function (event) {
        const trigger = event.target.closest('[data-ghost-search]');
        if (!trigger) return;
        window.location.hash = '#/search';
    });

    /* Portal also binds submit handlers directly to member signup forms
       at boot. For forms in a swapped-in body (defaultPrevented is false
       because no handler ran) replicate its magic-link submission. */
    document.addEventListener('submit', function (event) {
        const form = event.target;
        if (!form.matches || !form.matches('form[data-members-form]') || event.defaultPrevented) return;

        event.preventDefault();

        const errorEl = form.querySelector('[data-members-error]');
        const emailInput = form.querySelector('input[data-members-email]');
        const nameInput = form.querySelector('input[data-members-name]');
        const labels = Array.prototype.map.call(
            form.querySelectorAll('input[data-members-label]'),
            function (input) { return input.value; }
        );

        if (errorEl) errorEl.innerText = '';
        form.classList.remove('success', 'invalid', 'error');
        form.classList.add('loading');

        fetch('/members/api/send-magic-link/', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                email: emailInput ? emailInput.value : '',
                emailType: form.dataset.membersForm || undefined,
                labels: labels,
                name: (nameInput && nameInput.value) || undefined,
                autoRedirect: (form.dataset.membersAutoredirect || 'true') === 'true'
            })
        }).then(function (res) {
            form.classList.remove('loading');
            if (res.ok) {
                form.classList.add('success');
            } else {
                if (errorEl) {
                    errorEl.innerText = 'There was an error sending the email, please try again';
                }
                form.classList.add('error');
            }
        });
    });
})();
